import React from 'react';
import {
  Table, TableBody, TableCell, TableHead, TableRow,
  TableContainer, Paper, Chip, Typography
} from '@mui/material';

export default function DeductiblesTable({ deductibles }) {
  if (!deductibles || deductibles.length === 0) {
    return <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>Nessuno scoperto o franchigia applicabile.</Typography>;
  }

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 1 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><strong>Garanzia</strong></TableCell>
            <TableCell align="center"><strong>Scoperto</strong></TableCell>
            <TableCell align="center"><strong>Franchigia</strong></TableCell>
            <TableCell align="center"><strong>Limite</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deductibles.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell>
                <span style={{ marginRight: 6 }}>{item.emoji}</span>
                {item.name}
              </TableCell>
              <TableCell align="center">
                <Chip label={item.scoperto} size="small" variant="outlined" sx={{ fontFamily: 'monospace' }} />
              </TableCell>
              <TableCell align="center">
                <Chip label={item.franchigia} size="small" variant="outlined" sx={{ fontFamily: 'monospace' }} />
              </TableCell>
              <TableCell align="center">
                {item.limite
                  ? <Chip label={item.limite} size="small" color="warning" variant="outlined" sx={{ fontFamily: 'monospace' }} />
                  : <Typography variant="body2" color="text.disabled">—</Typography>
                }
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}